import React, { useState, useEffect } from "react";
import axios from "axios";
import AdjuntoEstandar from "./AdjuntoEstandar";
import EliminaEstandar from "./EliminaEstandar";

function InfoAnexos(props) {
  const [list, setList] = useState([]);

  useEffect(() => {
    axios({
      auth: {
        username: "admin.icontec@icontec.org",
        password: "quAngEraMuSTerGerEDE",
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerAnexosEstandares/" +
        props.id,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);
  return (
    <div>
      <div className="container">
        <div className="text-center">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">
                  Estandares Asistencial
                </h6>
                <hr />

                <div class="table-responsive">
                  <table
                    class="table table-bordered"
                    id="dataTable"
                    width="100%"
                    cellspacing="0"
                  >
                    <thead>
                      <tr>
                        <th>Id</th>

                        <th>Anexos</th>
                        <th>Eliminar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.map((item) => {
                        return (
                          <tr>
                            <td>{item.id}</td>

                            <td>
                              <a href={item.url} download>
                                {" "}
                                Descargar Adjunto{" "}
                              </a>
                            </td>
                            <td>
                              <EliminaEstandar id={item.id} />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InfoAnexos;
